// extracted by mini-css-extract-plugin
export default {"link":"uOhGAZ","EcomFeedbackCheckoutButton":"ZqjSYD","ecomFeedbackCheckoutButton":"ZqjSYD","label":"aaKn4M"};